var _path, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyWishlist(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--sunburst-effect--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Sparkles--inject-109",
    d: "M365.77,252.8c19.29-.35,38.59-.58,57.88-1l28.94-.68c9.65-.3,19.3-.53,29-.89v-.42c-9.65-.36-19.3-.59-29-.89l-28.94-.68c-19.29-.44-38.59-.67-57.88-1s-38.59-.58-57.89-.67c-6.07,0-12.14,0-18.21,0,6-1,12-2.11,17.94-3.16,19-3.44,37.93-7.09,56.89-10.72s37.9-7.27,56.82-11.05l28.39-5.7c9.45-2,18.91-3.87,28.35-5.9l-.08-.42c-9.56,1.32-19.1,2.77-28.65,4.15l-28.62,4.37c-19.08,2.91-38.12,6-57.19,9s-38.1,6.13-57.12,9.39c-6,1.06-12,2.1-18,3.18q8.61-3.11,17.2-6.24c18.1-6.69,36.13-13.57,54.16-20.43s36.07-13.75,54.05-20.76l27-10.54c9-3.58,17.95-7.09,26.9-10.73l-.15-.4c-9.19,3-18.33,6-27.5,9.06l-27.43,9.27c-18.28,6.18-36.49,12.56-54.74,18.83s-36.46,12.66-54.62,19.17c-5.77,2.1-11.53,4.19-17.29,6.31q8-4.58,15.95-9.18c16.66-9.73,33.22-19.64,49.79-29.53s33.13-19.8,49.62-29.83L426,149.66c8.21-5.09,16.45-10.11,24.62-15.24l-.21-.37c-8.53,4.51-17,9.13-25.51,13.7l-25.4,13.88c-16.93,9.27-33.76,18.71-50.64,28.06s-33.71,18.79-50.47,28.36q-8,4.6-15.92,9.22,7.06-5.9,14.1-11.82c14.72-12.47,29.31-25.1,43.91-37.72s29.19-25.25,43.69-38l21.73-19.12c7.2-6.43,14.45-12.81,21.61-19.29l-.28-.32c-7.62,5.92-15.16,11.95-22.74,17.92L381.88,137c-15.06,12.06-30,24.28-45,36.42S307,197.8,292.11,210.13Q285.06,216,278,222q6-7,11.85-14.09c12.33-14.84,24.5-29.82,36.69-44.77s24.36-29.94,36.42-45l18.09-22.61c6-7.58,12-15.12,17.92-22.74l-.32-.28c-6.48,7.16-12.86,14.41-19.29,21.61l-19.12,21.73c-12.74,14.5-25.32,29.13-38,43.69S297,188.71,284.55,203.43q-5.93,7-11.82,14.1,4.63-8,9.22-15.92c9.57-16.76,18.95-33.62,28.36-50.47s18.79-33.71,28.06-50.64l13.88-25.4c4.57-8.51,9.19-17,13.7-25.51l-.37-.21c-5.13,8.17-10.15,16.41-15.24,24.62l-15,24.72c-10,16.49-19.88,33.09-29.83,49.62s-19.8,33.13-29.53,49.79q-4.59,8-9.18,16c2.12-5.76,4.21-11.52,6.31-17.29,6.51-18.16,12.83-36.39,19.17-54.62s12.65-36.46,18.83-54.74L320.33,60c3-9.17,6.1-18.31,9.06-27.5l-.4-.15c-3.64,8.95-7.15,17.93-10.73,26.9l-10.54,27c-7,18-13.83,36-20.76,54.05s-13.74,36.06-20.43,54.16q-3.12,8.6-6.24,17.2c1.08-6,2.12-12,3.18-18,3.26-19,6.31-38.07,9.39-57.12s6.13-38.11,9-57.19l4.36-28.62c1.39-9.55,2.84-19.09,4.16-28.65l-.42-.08c-2,9.44-3.94,18.9-5.9,28.35l-5.7,28.39c-3.78,18.92-7.36,37.88-11,56.82s-7.28,37.91-10.72,56.89c-1,6-2.13,12-3.16,17.94,0-6.07,0-12.14,0-18.21-.09-19.3-.39-38.59-.67-57.89s-.58-38.59-1-57.88L251.1,47.4c-.3-9.64-.53-19.29-.89-28.94h-.42c-.36,9.65-.59,19.3-.89,28.94l-.68,28.95c-.44,19.29-.67,38.59-1,57.88s-.58,38.59-.67,57.89c0,6.07,0,12.14,0,18.21-1-6-2.11-12-3.16-17.94-3.44-19-7.09-37.93-10.72-56.89s-7.27-37.9-11.05-56.82l-5.7-28.39c-2-9.45-3.87-18.91-5.9-28.35l-.42.08c1.32,9.56,2.77,19.1,4.15,28.65l4.37,28.62c2.91,19.08,6,38.12,9,57.19s6.13,38.1,9.39,57.12c1.06,6,2.1,12,3.18,18q-3.11-8.61-6.24-17.2c-6.69-18.1-13.57-36.13-20.43-54.16s-13.75-36.07-20.76-54l-10.54-27c-3.58-9-7.09-18-10.73-26.9l-.4.15c3,9.19,6,18.33,9.06,27.5l9.27,27.43c6.18,18.28,12.56,36.49,18.83,54.74s12.66,36.46,19.17,54.62c2.1,5.77,4.19,11.53,6.31,17.29q-4.58-8-9.18-16c-9.73-16.66-19.64-33.22-29.53-49.79s-19.8-33.13-29.83-49.62L149.66,74c-5.09-8.21-10.11-16.45-15.24-24.62l-.37.21c4.51,8.53,9.13,17,13.7,25.51l13.88,25.4c9.27,16.93,18.71,33.76,28.06,50.64s18.79,33.71,28.36,50.47q4.6,8,9.22,15.92-5.9-7.07-11.82-14.1c-12.47-14.72-25.1-29.31-37.72-43.91s-25.25-29.19-38-43.69L120.62,94.1c-6.43-7.2-12.81-14.45-19.29-21.61l-.32.28c5.92,7.62,11.95,15.16,17.92,22.74L137,118.12c12.06,15.06,24.28,30,36.42,45s24.36,29.93,36.69,44.77Q216,214.94,222,222q-7-6-14.09-11.85c-14.84-12.33-29.82-24.5-44.78-36.69s-29.93-24.36-45-36.42L95.51,118.93c-7.58-6-15.12-12-22.74-17.92l-.28.32c7.16,6.48,14.41,12.86,21.6,19.29l21.74,19.12c14.5,12.74,29.13,25.32,43.69,38s29.19,25.25,43.9,37.72q7.05,5.93,14.11,11.82-8-4.64-15.92-9.22c-16.76-9.57-33.62-19-50.47-28.36s-33.71-18.79-50.64-28.06L75.1,147.75c-8.51-4.57-17-9.19-25.51-13.7l-.21.37c8.17,5.13,16.41,10.15,24.62,15.24l24.72,15.05c16.49,10,33.09,19.88,49.62,29.83s33.13,19.8,49.79,29.53q8,4.59,16,9.18c-5.76-2.12-11.52-4.21-17.29-6.31-18.16-6.51-36.39-12.83-54.62-19.17s-36.46-12.65-54.74-18.83L60,179.67c-9.17-3-18.31-6.1-27.5-9.06l-.15.4c8.95,3.64,17.93,7.15,26.9,10.73l27,10.54c18,7,36,13.83,54.05,20.76s36.06,13.74,54.16,20.43q8.6,3.12,17.2,6.24c-6-1.08-12-2.12-18-3.18-19-3.26-38.07-6.31-57.12-9.39s-38.11-6.13-57.19-9l-28.62-4.37c-9.55-1.38-19.09-2.83-28.65-4.15l-.08.42c9.44,2,18.9,3.94,28.35,5.9l28.39,5.7c18.92,3.78,37.88,7.36,56.82,11.05s37.91,7.28,56.89,10.72c6,1,12,2.13,17.94,3.16-6.07,0-12.14,0-18.21,0-19.3.09-38.59.39-57.89.67s-38.59.58-57.88,1l-28.95.68c-9.64.3-19.29.53-28.94.89v.42c9.65.36,19.3.59,28.94.89l28.95.68c19.29.44,38.59.67,57.88,1s38.59.58,57.89.67c6.07,0,12.14,0,18.21,0-6,1-12,2.11-17.94,3.16-19,3.44-37.93,7.09-56.89,10.72s-37.9,7.27-56.82,11l-28.39,5.7c-9.45,2-18.91,3.87-28.35,5.9l.08.42c9.56-1.32,19.1-2.77,28.65-4.15l28.62-4.37c19.08-2.91,38.12-6,57.19-9s38.1-6.13,57.12-9.39c6-1.06,12-2.1,18-3.18q-8.61,3.1-17.2,6.24c-18.1,6.69-36.13,13.57-54.16,20.43s-36.07,13.75-54,20.76l-27,10.54c-9,3.58-18,7.09-26.9,10.73l.15.4c9.19-3,18.33-6,27.5-9.06l27.43-9.27c18.28-6.18,36.49-12.56,54.74-18.83s36.46-12.66,54.62-19.17c5.77-2.1,11.53-4.19,17.29-6.31q-8,4.58-16,9.18c-16.66,9.73-33.22,19.64-49.79,29.53s-33.13,19.8-49.62,29.83L74,350.34c-8.21,5.09-16.45,10.11-24.62,15.24l.21.37c8.53-4.51,17-9.13,25.51-13.7l25.4-13.88c16.93-9.27,33.76-18.71,50.64-28.06s33.71-18.79,50.47-28.36q8-4.6,15.92-9.22-7.07,5.89-14.11,11.82c-14.71,12.47-29.3,25.1-43.9,37.72s-29.19,25.25-43.69,38L94.09,379.38c-7.19,6.43-14.44,12.81-21.6,19.29l.28.32c7.62-5.92,15.16-11.95,22.74-17.92L118.12,363c15.06-12.06,30-24.28,45-36.42s29.94-24.36,44.78-36.69Q214.94,284,222,278q-5.94,7-11.84,14.09c-12.33,14.84-24.5,29.82-36.69,44.77s-24.36,29.94-36.42,45l-18.09,22.61c-6,7.58-12,15.12-17.92,22.74l.32.28c6.48-7.16,12.86-14.41,19.29-21.61l19.12-21.73c12.74-14.5,25.32-29.13,38-43.69s25.25-29.19,37.72-43.91q5.93-7,11.82-14.1-4.64,7.95-9.22,15.92c-9.57,16.76-19,33.62-28.36,50.47s-18.79,33.71-28.06,50.64l-13.88,25.4c-4.57,8.51-9.19,17-13.7,25.51l.37.21c5.13-8.17,10.15-16.41,15.24-24.62l15.05-24.72c10-16.49,19.88-33.09,29.83-49.62s19.8-33.13,29.53-49.79q4.59-8,9.18-15.95c-2.12,5.76-4.21,11.52-6.31,17.29-6.51,18.16-12.83,36.39-19.17,54.62s-12.65,36.46-18.83,54.74L179.67,440c-3,9.17-6.1,18.31-9.06,27.5l.4.15c3.64-8.95,7.15-17.93,10.73-26.9l10.54-27c7-18,13.83-36,20.76-54.05s13.74-36.06,20.43-54.16q3.12-8.59,6.24-17.2c-1.08,6-2.12,12-3.18,18-3.26,19-6.31,38.07-9.39,57.12s-6.13,38.11-9,57.19l-4.37,28.62c-1.38,9.55-2.83,19.09-4.15,28.65l.42.08c2-9.44,3.94-18.9,5.9-28.35l5.7-28.39c3.78-18.92,7.36-37.88,11.05-56.82s7.28-37.91,10.72-56.89c1-6,2.13-12,3.16-17.94,0,6.07,0,12.14,0,18.21.09,19.3.39,38.59.67,57.89s.58,38.59,1,57.88l.68,29c.3,9.64.53,19.29.89,28.94h.42c.36-9.65.59-19.3.89-28.94l.68-29c.44-19.29.67-38.59,1-57.88s.58-38.59.67-57.89c0-6.07,0-12.14,0-18.21,1,6,2.11,12,3.16,17.94,3.44,19,7.09,37.93,10.72,56.89s7.27,37.9,11,56.82l5.7,28.39c2,9.45,3.87,18.91,5.9,28.35l.42-.08c-1.32-9.56-2.77-19.1-4.16-28.65l-4.36-28.62c-2.91-19.08-6-38.12-9-57.19s-6.13-38.1-9.39-57.12c-1.06-6-2.1-12-3.18-18q3.1,8.61,6.24,17.2c6.69,18.1,13.57,36.13,20.43,54.16s13.75,36.07,20.76,54.05l10.54,27c3.58,9,7.09,17.95,10.73,26.9l.4-.15c-3-9.19-6-18.33-9.06-27.5l-9.27-27.43c-6.18-18.28-12.56-36.49-18.83-54.74s-12.66-36.46-19.17-54.62c-2.1-5.77-4.19-11.53-6.31-17.29q4.58,8,9.18,15.95c9.73,16.66,19.64,33.22,29.53,49.79s19.8,33.13,29.83,49.62l15,24.72c5.09,8.21,10.11,16.45,15.24,24.62l.37-.21c-4.51-8.53-9.13-17-13.7-25.51l-13.88-25.4c-9.27-16.93-18.71-33.76-28.06-50.64S291.52,315.15,282,298.39q-4.6-8-9.22-15.92,5.89,7.06,11.82,14.1c12.47,14.72,25.1,29.31,37.72,43.91s25.25,29.19,38,43.69l19.12,21.73c6.43,7.2,12.81,14.45,19.29,21.61l.32-.28c-5.92-7.62-11.95-15.16-17.92-22.74L363,381.88c-12.06-15.06-24.28-30-36.42-45S302.2,307,289.87,292.11Q284,285.06,278,278q7,5.94,14.08,11.84c14.84,12.33,29.81,24.5,44.77,36.69s30.34,24.36,45.4,36.42l22.21,18.09c7.58,6,15.12,12,22.74,17.92l.28-.32c-7.16-6.48-14.41-12.86-21.61-19.29l-21.73-19.12c-14.5-12.74-29.13-25.32-43.69-38S311.29,297,296.57,284.55q-7-5.93-14.1-11.82,7.95,4.63,15.92,9.22c16.76,9.57,33.62,18.95,50.47,28.36s33.71,18.79,50.64,28.06l25.4,13.88c8.51,4.57,17,9.19,25.51,13.7l.21-.37c-8.17-5.13-16.41-10.15-24.62-15.24l-24.72-15c-16.49-10-33.09-19.88-49.62-29.83s-33.13-19.8-49.79-29.53q-8-4.59-15.95-9.18c5.76,2.12,11.52,4.21,17.29,6.31,18.16,6.51,36.39,12.83,54.62,19.17s36.46,12.65,54.74,18.83L440,320.33c9.17,3,18.31,6.1,27.5,9.06l.15-.4c-8.95-3.64-17.93-7.15-26.9-10.73l-27-10.54c-18-7-36-13.83-54.05-20.76s-36.06-13.74-54.16-20.43q-8.59-3.12-17.21-6.24c6,1.08,12,2.12,18,3.18,19,3.26,38.07,6.31,57.12,9.39s38.11,6.13,57.19,9l28.62,4.37c9.55,1.38,19.09,2.83,28.65,4.15l.08-.42c-9.44-2-18.9-3.94-28.35-5.9l-28.39-5.7c-18.92-3.78-37.88-7.36-56.82-11s-37.91-7.28-56.89-10.72c-6-1-12-2.13-17.94-3.16,6.07,0,12.14,0,18.21,0C327.18,253.38,346.47,253.08,365.77,252.8Z",
    style: {
      fill: "#9D6B6B",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shopping-bags--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--shopping-bags--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bag--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.36,169.67l1.24-13.92L163.72,220.56l12.41,5.22,4.83,8.38,112.88-64.82ZM197.2,219c-1.8,1-3.12.27-2.95-1.64a7.74,7.74,0,0,1,3.57-5.33c1.8-1,3.12-.3,3,1.64A7.72,7.72,0,0,1,197.2,219Zm52.93-30.11c-1.8,1-3.13.28-3-1.64a7.78,7.78,0,0,1,3.57-5.33c1.81-1,3.14-.3,3,1.64A7.67,7.67,0,0,1,250.13,188.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.36 169.67 293.84 169.35 268.13 184.12 276.6 155.75 275.36 169.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "275.36 169.67 274.6 180.39 268.13 184.12 276.6 155.75 275.36 169.67",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,234.16,146.16,394l134-77.11,13.71-147.52Zm32.57-3c-1.73,1-3.11.16-3.11-1.82a6.86,6.86,0,0,1,3.11-5.39c1.72-1,3.11-.18,3.11,1.82A6.83,6.83,0,0,1,213.53,231.11ZM266,200.81c-1.72,1-3.12.16-3.12-1.82A6.87,6.87,0,0,1,266,193.6c1.71-1,3.11-.18,3.11,1.82A6.86,6.86,0,0,1,266,200.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.96 234.16 146.16 393.98 97.53 357.63 163.72 220.56 176.12 225.78 180.96 234.16",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "180.96 234.16 146.16 393.98 97.53 357.63 163.72 220.56 176.12 225.78 180.96 234.16",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.53 357.63 131.25 355 146.16 393.98 97.53 357.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "131.25 355 176.13 225.79 180.96 234.16 146.16 393.98 131.25 355",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.49,177.45v-7.1l-113,65.23L204.67,239l1.45,6.4L204,446.33l113-65.24,2.17-200.94Zm-74,58.43c-1.72,1-3.12.16-3.12-1.83a6.85,6.85,0,0,1,3.12-5.38c1.72-1,3.11-.18,3.11,1.82A6.86,6.86,0,0,1,223.54,235.88Zm52.6-30.51c-1.72,1-3.11.16-3.11-1.83a6.88,6.88,0,0,1,3.11-5.39c1.72-1,3.11-.17,3.11,1.83A6.85,6.85,0,0,1,276.14,205.37Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.49,177.45v-7.1l-113,65.23L204.67,239l1.45,6.4L204,446.33l113-65.24,2.17-200.94Zm-74,58.43c-1.72,1-3.12.16-3.12-1.83a6.85,6.85,0,0,1,3.12-5.38c1.72-1,3.11-.18,3.11,1.82A6.86,6.86,0,0,1,223.54,235.88Zm52.6-30.51c-1.72,1-3.11.16-3.11-1.83a6.88,6.88,0,0,1,3.11-5.39c1.72-1,3.11-.17,3.11,1.83A6.85,6.85,0,0,1,276.14,205.37Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.12,245.39,204,446.33l113-65.24,2.17-200.94Zm31.28,2c-1.71,1-3.11.16-3.11-1.82a6.89,6.89,0,0,1,3.11-5.39c1.72-1,3.12-.17,3.12,1.82A6.84,6.84,0,0,1,237.4,247.39ZM290,216.88c-1.72,1-3.11.16-3.11-1.83a6.88,6.88,0,0,1,3.11-5.39c1.73-1,3.11-.17,3.11,1.83A6.8,6.8,0,0,1,290,216.88Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.53 409.84 178.85 404.4 203.95 446.32 146.53 409.84",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.53 409.84 178.85 404.4 203.95 446.32 146.53 409.84",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.85 404.4 204.67 238.99 206.12 245.39 203.95 446.32 178.85 404.4",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.85 404.4 204.67 238.99 206.12 245.39 203.95 446.32 178.85 404.4",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.5 235.58 204.67 238.99 178.85 404.4 146.53 409.84 184.5 235.58",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "184.5 235.58 204.67 238.99 178.85 404.4 146.53 409.84 184.5 235.58",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.49 170.34 290.4 196.73 319.11 180.16 297.49 177.44 297.49 170.34",
    style: {
      fill: "#9D6B6B",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "297.49 177.44 297.49 192.64 319.11 180.16 297.49 177.44",
    style: {
      fill: "#9D6B6B",
      opacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bag--inject-109"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "378.1 378.68 338.36 192.74 326.96 191.54 320.94 182.7 326.1 348.65 378.1 378.68",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.1 378.68 338.36 192.74 326.96 191.54 320.94 182.7 326.1 348.65 378.1 378.68",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.96 191.54 326.72 199.46 319.79 203.46 320.94 182.71 326.96 191.54",
    style: {
      fill: "#9D6B6B",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,245.6l5.16,165.94,108.92-62.89-5.15-165.94Zm32.51,3.52c-1.72,1-3.11.16-3.11-1.83a6.88,6.88,0,0,1,3.11-5.39c1.72-1,3.12-.17,3.12,1.83A6.84,6.84,0,0,1,244.52,249.12Zm52.6-30.51c-1.72,1-3.11.16-3.11-1.83a6.86,6.86,0,0,1,3.11-5.38c1.72-1,3.12-.18,3.11,1.82A6.83,6.83,0,0,1,297.12,218.61Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,245.6l5.16,165.94,108.92-62.89-5.15-165.94Zm32.51,3.52c-1.72,1-3.11.16-3.11-1.83a6.88,6.88,0,0,1,3.11-5.39c1.72-1,3.12-.17,3.12,1.83A6.84,6.84,0,0,1,244.52,249.12Zm52.6-30.51c-1.72,1-3.11.16-3.11-1.83a6.86,6.86,0,0,1,3.11-5.38c1.72-1,3.12-.18,3.11,1.82A6.83,6.83,0,0,1,297.12,218.61Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.01 245.59 224.49 247.05 229.43 255.63 269.17 441.57 217.16 411.55 212.01 245.59",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.01 245.59 224.49 247.05 229.43 255.63 269.17 441.57 217.16 411.55 212.01 245.59",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.16 402.85 224.49 247.05 212.01 245.59 217.16 411.55 243.16 402.85",
    style: {
      fill: "#9D6B6B",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "269.17 441.57 243.16 402.85 217.16 411.55 269.17 441.57",
    style: {
      fill: "#9D6B6B",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.36,192.74,229.43,255.63l39.74,185.94L378.1,378.68Zm-73.87,66.93A2.15,2.15,0,0,1,261.1,258a5.25,5.25,0,0,1,2.3-5c1.57-.92,3.09-.16,3.39,1.7A5.2,5.2,0,0,1,264.49,259.67Zm53.34-30.6c-1.47.9-3.07.15-3.56-1.67a4.65,4.65,0,0,1,1.77-4.94c1.47-.91,3.07-.17,3.57,1.67A4.64,4.64,0,0,1,317.83,229.07Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.36,192.74,229.43,255.63l39.74,185.94L378.1,378.68Zm-73.87,66.93A2.15,2.15,0,0,1,261.1,258a5.25,5.25,0,0,1,2.3-5c1.57-.92,3.09-.16,3.39,1.7A5.2,5.2,0,0,1,264.49,259.67Zm53.34-30.6c-1.47.9-3.07.15-3.56-1.67a4.65,4.65,0,0,1,1.77-4.94c1.47-.91,3.07-.17,3.57,1.67A4.64,4.64,0,0,1,317.83,229.07Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Hand--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.89,68.68c-12.72,9.17-17.65,11-26.66,22.94s-15,19.39-19.51,26.18-7.23,18.64-11.37,28.14c-3,7-7.07,14.61-7.07,16.11,0,2.23,2.15,4.32,7.81,3.87a9.24,9.24,0,0,0,4.68-1.58,18,18,0,0,0,1.2,3.79c1.5,3.64,6.31,11.13,8.88,12.73s6,6.34,11.13,4.81,6.69-4.81,6.69-4.81,2.17,2.68,6.74,1.09a11.87,11.87,0,0,0,6.44-5.81s2.33,2.37,6.4,1,5.93-5.76,5.93-5.76a6.37,6.37,0,0,0,6.38-1.45c2.93-2.77,2.73-5,3.51-9.87s.13-6.45-2.4-11.23c0,0,1.2-5.21,2.52-11.46,1.71-8.09-.49-14.58,1.51-17.48,1-1.48,5.95-5,10.4-7.24C311.14,109,362,82.94,362,82.94s12.71-8-.34-34.14c-11.57-23.19-30-18.31-30-18.31S288.61,63.11,280.89,68.68Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.29,60.65c-.3,5.91-2.31,11.49-9.72,17-9.37,7-54.14,29.69-59.45,31.35-3.86,1.2-8.83-5.47-8.19-.57s4.45,9.87,3.89,14.88h0a6.73,6.73,0,0,1,.88-3.49c1-1.48,5.95-5,10.4-7.24C311.14,109,362,82.94,362,82.94S370.74,77.43,366.29,60.65Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,167.48a31.7,31.7,0,0,0,1.14-10.62,38.5,38.5,0,0,0-4.22-15.3c-1.29-2.52-3-5.05-5.64-6.1s-6.28.16-6.85,2.94c-2.83-1.36-6.37.16-8.28,2.65s-2.57,5.7-3.11,8.79c-1.56-.37-3.13.66-4.13,1.92s-1.67,2.76-2.76,3.94a1.38,1.38,0,0,1-.66.44c-.54.12-1-.38-1.26-.87a6.54,6.54,0,0,1-.08-5.12,24,24,0,0,1,2.51-4.61c1.33-2.13,5.05-11,3.67-13.64-2.34,5.83-5.23,7.41-5.7,8.88-3.48,11-8,16.88-15.77,23.56a17.79,17.79,0,0,0,1.21,3.79c1.49,3.64,6.3,11.13,8.87,12.73s6,6.34,11.14,4.81,6.68-4.81,6.68-4.81,2.17,2.68,6.74,1.09a11.82,11.82,0,0,0,6.44-5.81,5.94,5.94,0,0,0,5.28,1.25A37.17,37.17,0,0,0,280,167.48Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,118.74c-.16-.22-.34,0-.27.18,1.1,3.33,2.19,6.69,2.12,10.24a14.31,14.31,0,0,1-.82,4.59,12.92,12.92,0,0,1-.93,2,11,11,0,0,0-1.33,2.22c-.17.61.53.91,1,.77.79-.24,1.31-1.34,1.7-2a13.51,13.51,0,0,0,1-2.17,16.85,16.85,0,0,0,1-5A16.48,16.48,0,0,0,271,118.74Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.58,129.38c2,3.63,4.3,7.92,3.21,12.3a43.18,43.18,0,0,1-16,22.66,66.14,66.14,0,0,0,6.88-7.44A47.87,47.87,0,0,0,243,143.76a13.37,13.37,0,0,0,1.17-4.73c0-3.34-1.45-6.52-2.55-9.65Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.87,118.27c2.85,7.87,1.62,16.86-5,22.51l-.71-.84c6.63-5.13,8.13-13.93,5.7-21.67Z",
    style: {
      fill: "#b16668"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cord--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.94,257.49a1,1,0,0,1-.94-.67l-21.19-60.45a34.66,34.66,0,0,1,15.36-41.46,28.45,28.45,0,0,1,41.06,15.21l19.49,55.55a1,1,0,0,1-1.89.66l-19.49-55.55a26.45,26.45,0,0,0-38.17-14.14,32.69,32.69,0,0,0-14.48,39.07l21.2,60.45a1,1,0,0,1-.62,1.28A.91.91,0,0,1,263.94,257.49Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.48,245.31a1,1,0,0,1-1-.85l-7-46.13a42.89,42.89,0,0,1,21.08-43.87,23,23,0,0,1,34.23,16.44l6.33,41.69a1,1,0,0,1-2,.3L289.8,171.2a21,21,0,0,0-31.25-15A40.92,40.92,0,0,0,238.45,198l7,46.13a1,1,0,0,1-.84,1.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.85,200.66l-1.94,1.12-1.79-29a19,19,0,0,0-28.4-15.25,45.17,45.17,0,0,0-22.63,42.12L237,231.16l-1.94,1.12-2-32.54a47.2,47.2,0,0,1,23.63-44,21,21,0,0,1,31.4,16.87Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.35,231.74h-.17a1,1,0,0,1-.81-1.16l5.17-30.08a63.64,63.64,0,0,1,31-44.47A15.78,15.78,0,0,1,282,172.36l-4.81,28a1,1,0,0,1-2-.33L280,172a13.78,13.78,0,0,0-20.47-14.27,61.72,61.72,0,0,0-30,43.08l-5.17,30.08A1,1,0,0,1,223.35,231.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.93,158.38l-7.69,27.7-2.48,1.43L276,157.84a6.77,6.77,0,0,0-9.91-7.68A101.08,101.08,0,0,0,219,211l-1.56,5.61L214.94,218l2.1-7.57a103.05,103.05,0,0,1,48-62,8.77,8.77,0,0,1,12.84,9.95Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.51,216.49a1,1,0,0,1-.54-.16,1,1,0,0,1-.3-1.38l5.63-8.71a187.29,187.29,0,0,1,63.4-60.32,4.92,4.92,0,0,1,6.59,6.92l-21.11,32.7a1,1,0,0,1-1.68-1.08l21.11-32.7a2.92,2.92,0,0,0-3.91-4.11A185.27,185.27,0,0,0,204,207.32L198.35,216A1,1,0,0,1,197.51,216.49Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fingers--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250,185.67c5.17-1.54,6.69-4.81,6.69-4.81s2.17,2.68,6.74,1.09a11.87,11.87,0,0,0,6.44-5.81s2.33,2.37,6.4,1,5.93-5.76,5.93-5.76a6.37,6.37,0,0,0,6.38-1.45c2.93-2.77,2.73-5,3.51-9.87s.13-6.45-2.4-11.23c-2.72-5-6.56-11.23-9-12a3.94,3.94,0,0,0-4,1,14.73,14.73,0,0,0-2.16-3c-1.47-1.47-4.18-1.25-5.88,1.29s-2.16,5-1.52,7c-2.78-3.85-5.68-4-7.93-1.42s-3.78,7.42-2.4,14.6c-3-1.35-6.79,1.38-8.1,4.59s-3.6,10.49-3.6,10.49S244.82,187.2,250,185.67Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.07,160a23.68,23.68,0,0,0,.3-2.82,7,7,0,0,1-3,4.09c-1.63.86-4.11.19-4.46-1.62a8.91,8.91,0,0,1-2.28,5.63c-1.21,1.47-3,2.79-4.86,2.34-2.18-.52-3.07-3.06-3.61-5.23a17.33,17.33,0,0,1-3.23,7.19,8.26,8.26,0,0,1-6.94,3.19c-2.63-.27-5.07-2.57-5-5.22a11.94,11.94,0,0,1-2.22,7c-1.53,2-4,3.56-6.44,2.58a6.75,6.75,0,0,1-4.27-5.59,23.38,23.38,0,0,0-.14-2.79c-.48,1.47-.81,2.51-.81,2.51s-.32,16,4.84,14.44,6.69-4.81,6.69-4.81,2.17,2.68,6.74,1.09a11.87,11.87,0,0,0,6.44-5.81s2.33,2.37,6.4,1,5.93-5.76,5.93-5.76a6.37,6.37,0,0,0,6.38-1.45C291.49,167.11,291.29,164.88,292.07,160Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.85,137.17a64.65,64.65,0,0,1,8.46,16.44c.79,3,.23,6.16-.38,9.13a38.42,38.42,0,0,1-2.75,8.59,36.33,36.33,0,0,0,1.11-4.34c.76-4.26,2-8.82,1-13.09-1.83-5.63-5.14-10.73-7.84-16Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.17,143a61.14,61.14,0,0,1,7,16.16c.93,4.46-.87,8.93-2.38,13.05a34.61,34.61,0,0,1-1.95,4c.52-1.37,1-2.74,1.45-4.14,1.1-4,2.69-8.53,1.81-12.63-.54-2.42-1.89-5.88-2.68-8.28a79,79,0,0,0-3.26-8.12Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.84,156.15c4,2.54,3,8.12,2.87,12.15a38.53,38.53,0,0,1-3,12.56,89.79,89.79,0,0,0,1.95-12.65c.12-4,1.47-9-1.78-12.06Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,148.78a82.78,82.78,0,0,0-5.29-8.14c-1.81-2.43-4.42-5.4-7.38-2.66l-.35.36-.24-.43c-1.42-2.53-3.39-5.1-6.34-2.76-1.93,1.85-3.22,5-2.42,7.66l1,3c-2-2.79-5.14-7.88-8.78-4.06-3.43,3.82-3.38,9.53-2.53,14.34l.17.9-.84-.37c-3-1.2-6.16,1.43-7.4,4-.55,1.27-1.56,4.24-2.07,5.56a22.13,22.13,0,0,0-1.6,11.59,30.54,30.54,0,0,0,.59,3.93,33.78,33.78,0,0,1-1.14-7.89,21.06,21.06,0,0,1,1.54-7.84c.49-1.4,1.43-4.35,1.95-5.68a8.81,8.81,0,0,1,4.28-4.42,5.2,5.2,0,0,1,4.25-.17l-.68.53c-1-5.1-1-11.17,2.69-15.28,2.87-3.14,6.52-1.33,8.53,1.71l-.89.45c-.9-3.14.51-6.52,2.78-8.69,3.46-2.67,6,0,7.59,3.13l-.6-.07c3.39-3,6.34-.07,8.29,2.88a71.57,71.57,0,0,1,4.92,8.41Z",
    style: {
      fill: "#b16668"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Logo--inject-109",
    d: "M341.24,295.58c-3.61-17.25-14.93-27.38-28.19-27.38a30.93,30.93,0,0,0-15.45,4.44C278.47,283.69,267,311.86,272,335.57c3.62,17.24,14.94,27.38,28.2,27.38a30.93,30.93,0,0,0,15.45-4.44C334.74,347.46,346.21,319.29,341.24,295.58Zm-9.34,33.94c-4.34,10.66-11.2,19.11-19.3,23.78a24.79,24.79,0,0,1-12.44,3.64c-10.84,0-19.4-8.66-22.32-22.6-2.16-10.31-.93-21.93,3.46-32.72s11.2-19.1,19.3-23.78a24.91,24.91,0,0,1,12.45-3.63c10.84,0,19.39,8.66,22.31,22.6C337.52,307.12,336.29,318.73,331.9,329.52Zm-29.44-33.69c-8.8,5.08-14.07,18-11.79,28.94s11.27,15.63,20.07,10.55,14.08-18,11.79-28.94S311.26,290.75,302.46,295.83Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tag--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--tag--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Discount--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Label--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.58,87V132l61.3,35.4,1.76-1,15.61-13.52-15.61-31.54L114.34,86Zm64.84,61.74a3.62,3.62,0,0,1-1.63-.5,8.31,8.31,0,0,1-3.74-6.5,3.42,3.42,0,0,1,.37-1.63,3.4,3.4,0,0,1,1.61.49,8.26,8.26,0,0,1,3.75,6.49A3.36,3.36,0,0,1,177.42,148.72Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.58,87V132l61.3,35.4,15.61-13.52-15.61-31.55Zm57.71,55.76c0-2.38,1.68-3.35,3.74-2.16a8.26,8.26,0,0,1,3.75,6.49c0,2.4-1.67,3.37-3.75,2.16A8.29,8.29,0,0,1,170.29,142.74Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.29,142.74a8.29,8.29,0,0,0,3.74,6.49c1.51.87,2.79.61,3.39-.51h0a3.53,3.53,0,0,1-1.63-.5,8.32,8.32,0,0,1-3.75-6.5,3.34,3.34,0,0,1,.38-1.62,1.89,1.89,0,0,0-1.41.53A2.9,2.9,0,0,0,170.29,142.74Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "112.58 86.98 114.34 85.96 175.64 121.36 173.88 122.38 112.58 86.98",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "173.88 122.38 189.49 153.92 191.25 152.91 175.64 121.36 173.88 122.38"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "189.49 153.92 173.88 167.44 175.64 166.42 191.25 152.91 189.49 153.92"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M137.23,123q1.85-1.39,1.84-5.7a17.26,17.26,0,0,0-.85-5.47,15.46,15.46,0,0,0-2.36-4.53,11.77,11.77,0,0,0-3.39-3,5.25,5.25,0,0,0-3.39-.87,3.13,3.13,0,0,0-2.36,1.81,9.57,9.57,0,0,0-.85,4.47,16.69,16.69,0,0,0,1.84,7.84,12.46,12.46,0,0,0,4.76,5.2Q135.38,124.38,137.23,123Zm-5.88-7a10.6,10.6,0,0,1-.44-3.41,6.31,6.31,0,0,1,.44-2.89.75.75,0,0,1,1.12-.32,3,3,0,0,1,1.12,1.61,10.6,10.6,0,0,1,.44,3.41,6.31,6.31,0,0,1-.44,2.89.75.75,0,0,1-1.12.32A3,3,0,0,1,131.35,116Zm25.08,22a15.46,15.46,0,0,0-2.36-4.53,11.81,11.81,0,0,0-3.39-3,5.33,5.33,0,0,0-3.39-.86,3.12,3.12,0,0,0-2.36,1.8,9.65,9.65,0,0,0-.85,4.48,16.62,16.62,0,0,0,1.84,7.83,12.43,12.43,0,0,0,4.76,5.21q2.91,1.68,4.75.29t1.85-5.71A17.53,17.53,0,0,0,156.43,138Zm-4.64,5.44a.73.73,0,0,1-1.11.33,2.9,2.9,0,0,1-1.12-1.62,10.22,10.22,0,0,1-.44-3.4,6.17,6.17,0,0,1,.44-2.89.75.75,0,0,1,1.12-.32,2.87,2.87,0,0,1,1.11,1.61,10.22,10.22,0,0,1,.45,3.4A6.09,6.09,0,0,1,151.79,143.39Zm-3.92-29.92-17,23.34,4.47,2.55,17-23.33Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M205.41,204.53l-.25,0a1,1,0,0,1-.73-1.21c8.25-33.15-27.79-56.56-29.33-57.54a1,1,0,1,1,1.08-1.68c14.44,9.2,37,32.13,30.2,59.7A1,1,0,0,1,205.41,204.53Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,285.25l.6,4.34,3.92,2a.44.44,0,0,1,0,.79l-4,1.91-.66,4.34a.45.45,0,0,1-.76.24l-3-3.17-4.32.71a.45.45,0,0,1-.47-.65l2.08-3.86-2-3.9a.45.45,0,0,1,.48-.64l4.31.78L63.24,285A.44.44,0,0,1,64,285.25Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,285.25l.6,4.34,3.92,2a.44.44,0,0,1,0,.79l-4,1.91-.66,4.34a.45.45,0,0,1-.76.24l-3-3.17-4.32.71a.45.45,0,0,1-.47-.65l2.08-3.86-2-3.9a.45.45,0,0,1,.48-.64l4.31.78L63.24,285A.44.44,0,0,1,64,285.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,170.5,58.73,174,64,172.45a.56.56,0,0,1,.67.74l-2,5.1,3.08,4.54a.56.56,0,0,1-.49.87l-5.47-.32-3.37,4.32a.55.55,0,0,1-1-.2l-1.39-5.3-5.16-1.87a.55.55,0,0,1-.11-1l4.62-3,.18-5.48A.55.55,0,0,1,54.49,170.5Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.49,170.5,58.73,174,64,172.45a.56.56,0,0,1,.67.74l-2,5.1,3.08,4.54a.56.56,0,0,1-.49.87l-5.47-.32-3.37,4.32a.55.55,0,0,1-1-.2l-1.39-5.3-5.16-1.87a.55.55,0,0,1-.11-1l4.62-3,.18-5.48A.55.55,0,0,1,54.49,170.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,64.08l2.8,2.3,3.48-1a.37.37,0,0,1,.44.49l-1.32,3.37,2,3a.36.36,0,0,1-.32.57l-3.61-.21-2.23,2.85a.36.36,0,0,1-.64-.13l-.91-3.5-3.4-1.23a.37.37,0,0,1-.08-.65l3-2,.12-3.62A.36.36,0,0,1,80.21,64.08Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.21,64.08l2.8,2.3,3.48-1a.37.37,0,0,1,.44.49l-1.32,3.37,2,3a.36.36,0,0,1-.32.57l-3.61-.21-2.23,2.85a.36.36,0,0,1-.64-.13l-.91-3.5-3.4-1.23a.37.37,0,0,1-.08-.65l3-2,.12-3.62A.36.36,0,0,1,80.21,64.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,280.15l1.41,3.85,4,1a.42.42,0,0,1,.16.73l-3.24,2.53.26,4.1a.42.42,0,0,1-.65.37l-3.4-2.3L425.85,292a.41.41,0,0,1-.55-.5l1.12-4-2.61-3.16a.41.41,0,0,1,.31-.68l4.1-.15,2.2-3.46A.42.42,0,0,1,431.16,280.15Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.16,280.15l1.41,3.85,4,1a.42.42,0,0,1,.16.73l-3.24,2.53.26,4.1a.42.42,0,0,1-.65.37l-3.4-2.3L425.85,292a.41.41,0,0,1-.55-.5l1.12-4-2.61-3.16a.41.41,0,0,1,.31-.68l4.1-.15,2.2-3.46A.42.42,0,0,1,431.16,280.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,311.58l.32,2.34L68.07,315a.24.24,0,0,1,0,.43l-2.13,1-.35,2.34a.24.24,0,0,1-.41.13l-1.64-1.71-2.33.38a.23.23,0,0,1-.25-.34l1.12-2.09L61,313.05a.24.24,0,0,1,.26-.34l2.32.41,1.67-1.68A.23.23,0,0,1,65.63,311.58Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.63,311.58l.32,2.34L68.07,315a.24.24,0,0,1,0,.43l-2.13,1-.35,2.34a.24.24,0,0,1-.41.13l-1.64-1.71-2.33.38a.23.23,0,0,1-.25-.34l1.12-2.09L61,313.05a.24.24,0,0,1,.26-.34l2.32.41,1.67-1.68A.23.23,0,0,1,65.63,311.58Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,467.15l2.12.62,1.72-1.39a.22.22,0,0,1,.36.16l.07,2.22L238,470a.22.22,0,0,1,0,.4l-2.09.74-.57,2.14a.22.22,0,0,1-.39.08l-1.35-1.75-2.21.11a.22.22,0,0,1-.2-.34l1.25-1.83-.79-2.06A.22.22,0,0,1,231.88,467.15Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,467.15l2.12.62,1.72-1.39a.22.22,0,0,1,.36.16l.07,2.22L238,470a.22.22,0,0,1,0,.4l-2.09.74-.57,2.14a.22.22,0,0,1-.39.08l-1.35-1.75-2.21.11a.22.22,0,0,1-.2-.34l1.25-1.83-.79-2.06A.22.22,0,0,1,231.88,467.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.34,94l.26,2.2,1.95,1a.22.22,0,0,1,0,.4l-2,.92-.38,2.18a.23.23,0,0,1-.39.12l-1.5-1.63-2.19.31a.22.22,0,0,1-.22-.33l1.08-1.93-1-2a.22.22,0,0,1,.24-.32l2.17.43L450,93.82A.23.23,0,0,1,450.34,94Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.34,94l.26,2.2,1.95,1a.22.22,0,0,1,0,.4l-2,.92-.38,2.18a.23.23,0,0,1-.39.12l-1.5-1.63-2.19.31a.22.22,0,0,1-.22-.33l1.08-1.93-1-2a.22.22,0,0,1,.24-.32l2.17.43L450,93.82A.23.23,0,0,1,450.34,94Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,399.2l.14,3.33,2.83,1.77a.34.34,0,0,1-.06.6l-3.12,1.17-.81,3.23a.34.34,0,0,1-.59.12l-2.07-2.6-3.33.23a.33.33,0,0,1-.3-.52L88,403.75l-1.25-3.09a.33.33,0,0,1,.4-.45l3.21.89L93,399A.33.33,0,0,1,93.51,399.2Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,399.2l.14,3.33,2.83,1.77a.34.34,0,0,1-.06.6l-3.12,1.17-.81,3.23a.34.34,0,0,1-.59.12l-2.07-2.6-3.33.23a.33.33,0,0,1-.3-.52L88,403.75l-1.25-3.09a.33.33,0,0,1,.4-.45l3.21.89L93,399A.33.33,0,0,1,93.51,399.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,170.23l-.35-2.18-2-1a.22.22,0,0,1,0-.4l2-1,.29-2.19a.22.22,0,0,1,.38-.13l1.56,1.56,2.18-.41a.23.23,0,0,1,.24.32l-1,2,1.06,1.94a.23.23,0,0,1-.24.33l-2.18-.34-1.52,1.6A.23.23,0,0,1,433,170.23Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,170.23l-.35-2.18-2-1a.22.22,0,0,1,0-.4l2-1,.29-2.19a.22.22,0,0,1,.38-.13l1.56,1.56,2.18-.41a.23.23,0,0,1,.24.32l-1,2,1.06,1.94a.23.23,0,0,1-.24.33l-2.18-.34-1.52,1.6A.23.23,0,0,1,433,170.23Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.61,208.33l-.35-2.19-2-.95a.22.22,0,0,1,0-.4l2-1,.28-2.19a.23.23,0,0,1,.38-.13l1.57,1.56,2.17-.4a.22.22,0,0,1,.24.32l-1,2,1.06,1.94a.22.22,0,0,1-.23.33l-2.19-.34L453,208.45A.22.22,0,0,1,452.61,208.33Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.61,208.33l-.35-2.19-2-.95a.22.22,0,0,1,0-.4l2-1,.28-2.19a.23.23,0,0,1,.38-.13l1.57,1.56,2.17-.4a.22.22,0,0,1,.24.32l-1,2,1.06,1.94a.22.22,0,0,1-.23.33l-2.19-.34L453,208.45A.22.22,0,0,1,452.61,208.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.36,263.73l2.18.37,1.54-1.59a.22.22,0,0,1,.38.13l.32,2.18,2,1a.23.23,0,0,1,0,.4l-2,1-.31,2.19a.22.22,0,0,1-.38.13l-1.55-1.58-2.18.37a.22.22,0,0,1-.23-.32l1-2-1-2A.22.22,0,0,1,409.36,263.73Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.36,263.73l2.18.37,1.54-1.59a.22.22,0,0,1,.38.13l.32,2.18,2,1a.23.23,0,0,1,0,.4l-2,1-.31,2.19a.22.22,0,0,1-.38.13l-1.55-1.58-2.18.37a.22.22,0,0,1-.23-.32l1-2-1-2A.22.22,0,0,1,409.36,263.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,85.41l.77,1.06,1.31,0a.13.13,0,0,1,.11.21l-.76,1.06.44,1.24a.13.13,0,0,1-.16.17l-1.25-.4-1,.8a.13.13,0,0,1-.21-.1V88.1L413,87.36a.13.13,0,0,1,0-.23l1.25-.42.36-1.25A.14.14,0,0,1,414.92,85.41Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.92,85.41l.77,1.06,1.31,0a.13.13,0,0,1,.11.21l-.76,1.06.44,1.24a.13.13,0,0,1-.16.17l-1.25-.4-1,.8a.13.13,0,0,1-.21-.1V88.1L413,87.36a.13.13,0,0,1,0-.23l1.25-.42.36-1.25A.14.14,0,0,1,414.92,85.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,50l2,.34,1.41-1.45a.21.21,0,0,1,.35.11l.29,2,1.81.89a.21.21,0,0,1,0,.37l-1.81.89-.28,2a.21.21,0,0,1-.35.12l-1.41-1.45-2,.35a.21.21,0,0,1-.22-.3l.94-1.79-.94-1.78A.21.21,0,0,1,196.15,50Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.15,50l2,.34,1.41-1.45a.21.21,0,0,1,.35.11l.29,2,1.81.89a.21.21,0,0,1,0,.37l-1.81.89-.28,2a.21.21,0,0,1-.35.12l-1.41-1.45-2,.35a.21.21,0,0,1-.22-.3l.94-1.79-.94-1.78A.21.21,0,0,1,196.15,50Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,208.08l1.29.22.92-.94a.13.13,0,0,1,.22.07l.19,1.3,1.18.58a.13.13,0,0,1,0,.23l-1.17.59-.19,1.29a.14.14,0,0,1-.23.08l-.91-.94-1.29.22a.13.13,0,0,1-.14-.19l.6-1.16-.61-1.16A.13.13,0,0,1,386.25,208.08Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.25,208.08l1.29.22.92-.94a.13.13,0,0,1,.22.07l.19,1.3,1.18.58a.13.13,0,0,1,0,.23l-1.17.59-.19,1.29a.14.14,0,0,1-.23.08l-.91-.94-1.29.22a.13.13,0,0,1-.14-.19l.6-1.16-.61-1.16A.13.13,0,0,1,386.25,208.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,434.09l1.27-.3.48-1.22a.13.13,0,0,1,.23,0l.69,1.12,1.3.07a.14.14,0,0,1,.1.22l-.86,1,.34,1.27a.13.13,0,0,1-.18.16l-1.21-.51-1.1.71a.14.14,0,0,1-.21-.12l.11-1.31-1-.83A.13.13,0,0,1,330.36,434.09Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.36,434.09l1.27-.3.48-1.22a.13.13,0,0,1,.23,0l.69,1.12,1.3.07a.14.14,0,0,1,.1.22l-.86,1,.34,1.27a.13.13,0,0,1-.18.16l-1.21-.51-1.1.71a.14.14,0,0,1-.21-.12l.11-1.31-1-.83A.13.13,0,0,1,330.36,434.09Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.56,108.59l.78,1.06,1.31,0a.13.13,0,0,1,.11.21l-.76,1.06.44,1.23a.13.13,0,0,1-.16.17l-1.25-.39-1,.8a.13.13,0,0,1-.21-.1v-1.31l-1.08-.74a.14.14,0,0,1,0-.24l1.24-.41.37-1.26A.13.13,0,0,1,446.56,108.59Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.56,108.59l.78,1.06,1.31,0a.13.13,0,0,1,.11.21l-.76,1.06.44,1.23a.13.13,0,0,1-.16.17l-1.25-.39-1,.8a.13.13,0,0,1-.21-.1v-1.31l-1.08-.74a.14.14,0,0,1,0-.24l1.24-.41.37-1.26A.13.13,0,0,1,446.56,108.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,155.44l-2.13-.59-1.69,1.43a.23.23,0,0,1-.37-.16l-.1-2.21-1.88-1.17a.22.22,0,0,1,0-.4l2.07-.78.53-2.15a.22.22,0,0,1,.39-.08l1.38,1.72,2.21-.16a.23.23,0,0,1,.2.35L371,153.09l.83,2A.23.23,0,0,1,371.52,155.44Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.52,155.44l-2.13-.59-1.69,1.43a.23.23,0,0,1-.37-.16l-.1-2.21-1.88-1.17a.22.22,0,0,1,0-.4l2.07-.78.53-2.15a.22.22,0,0,1,.39-.08l1.38,1.72,2.21-.16a.23.23,0,0,1,.2.35L371,153.09l.83,2A.23.23,0,0,1,371.52,155.44Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,146.47l-1.27.32-.45,1.23a.13.13,0,0,1-.23,0l-.71-1.11-1.31-.05a.13.13,0,0,1-.09-.22l.83-1-.36-1.26a.14.14,0,0,1,.18-.16l1.22.49,1.09-.73a.13.13,0,0,1,.2.12l-.08,1.3,1,.81A.14.14,0,0,1,359.36,146.47Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.36,146.47l-1.27.32-.45,1.23a.13.13,0,0,1-.23,0l-.71-1.11-1.31-.05a.13.13,0,0,1-.09-.22l.83-1-.36-1.26a.14.14,0,0,1,.18-.16l1.22.49,1.09-.73a.13.13,0,0,1,.2.12l-.08,1.3,1,.81A.14.14,0,0,1,359.36,146.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.57,458l1.28-.31.47-1.22a.14.14,0,0,1,.24,0l.68,1.12,1.31.07a.13.13,0,0,1,.09.22l-.85,1,.33,1.26a.13.13,0,0,1-.18.16l-1.21-.51-1.1.71a.13.13,0,0,1-.2-.12l.1-1.3-1-.83A.13.13,0,0,1,257.57,458Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.57,458l1.28-.31.47-1.22a.14.14,0,0,1,.24,0l.68,1.12,1.31.07a.13.13,0,0,1,.09.22l-.85,1,.33,1.26a.13.13,0,0,1-.18.16l-1.21-.51-1.1.71a.13.13,0,0,1-.2-.12l.1-1.3-1-.83A.13.13,0,0,1,257.57,458Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,184l1.72.3,1.22-1.26a.18.18,0,0,1,.31.1l.25,1.73,1.57.77a.18.18,0,0,1,0,.32l-1.57.78-.25,1.73a.18.18,0,0,1-.3.1L89,187.33l-1.73.29a.17.17,0,0,1-.18-.25l.81-1.55-.82-1.55A.18.18,0,0,1,87.3,184Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3,184l1.72.3,1.22-1.26a.18.18,0,0,1,.31.1l.25,1.73,1.57.77a.18.18,0,0,1,0,.32l-1.57.78-.25,1.73a.18.18,0,0,1-.3.1L89,187.33l-1.73.29a.17.17,0,0,1-.18-.25l.81-1.55-.82-1.55A.18.18,0,0,1,87.3,184Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,247l1.54-.88.15-1.76a.18.18,0,0,1,.3-.12l1.31,1.19,1.73-.4a.18.18,0,0,1,.2.25L98,246.86l.91,1.52a.18.18,0,0,1-.17.27l-1.76-.2-1.17,1.34a.18.18,0,0,1-.31-.09L95.13,248l-1.63-.69A.18.18,0,0,1,93.48,247Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.48,247l1.54-.88.15-1.76a.18.18,0,0,1,.3-.12l1.31,1.19,1.73-.4a.18.18,0,0,1,.2.25L98,246.86l.91,1.52a.18.18,0,0,1-.17.27l-1.76-.2-1.17,1.34a.18.18,0,0,1-.31-.09L95.13,248l-1.63-.69A.18.18,0,0,1,93.48,247Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,95.2l.1-1.31-1-.82a.13.13,0,0,1,0-.23l1.28-.31.46-1.23a.13.13,0,0,1,.24,0l.69,1.11,1.31.06a.13.13,0,0,1,.09.22l-.84,1,.34,1.26a.13.13,0,0,1-.17.16L210,94.6l-1.09.72A.14.14,0,0,1,208.7,95.2Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.7,95.2l.1-1.31-1-.82a.13.13,0,0,1,0-.23l1.28-.31.46-1.23a.13.13,0,0,1,.24,0l.69,1.11,1.31.06a.13.13,0,0,1,.09.22l-.84,1,.34,1.26a.13.13,0,0,1-.17.16L210,94.6l-1.09.72A.14.14,0,0,1,208.7,95.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,391.57l1,1.67,2,.08a.2.2,0,0,1,.14.33l-1.26,1.51.53,1.9a.2.2,0,0,1-.27.24l-1.83-.73-1.64,1.09a.2.2,0,0,1-.31-.18l.13-2L61,394.29a.2.2,0,0,1,.08-.35l1.91-.48.69-1.85A.19.19,0,0,1,64,391.57Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64,391.57l1,1.67,2,.08a.2.2,0,0,1,.14.33l-1.26,1.51.53,1.9a.2.2,0,0,1-.27.24l-1.83-.73-1.64,1.09a.2.2,0,0,1-.31-.18l.13-2L61,394.29a.2.2,0,0,1,.08-.35l1.91-.48.69-1.85A.19.19,0,0,1,64,391.57Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.23,289.22l1.1.9,1.36-.4a.14.14,0,0,1,.17.19l-.51,1.32.79,1.18a.14.14,0,0,1-.13.22l-1.41-.08-.87,1.12a.14.14,0,0,1-.25-.05l-.36-1.38-1.34-.48a.14.14,0,0,1,0-.25l1.2-.77,0-1.42A.15.15,0,0,1,404.23,289.22Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.23,289.22l1.1.9,1.36-.4a.14.14,0,0,1,.17.19l-.51,1.32.79,1.18a.14.14,0,0,1-.13.22l-1.41-.08-.87,1.12a.14.14,0,0,1-.25-.05l-.36-1.38-1.34-.48a.14.14,0,0,1,0-.25l1.2-.77,0-1.42A.15.15,0,0,1,404.23,289.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.78,180.77a1,1,0,0,1,1.39-.08,1,1,0,0,1-1.3,1.47A1,1,0,0,1,459.78,180.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.15,176.26a1,1,0,0,1,1.39-.08,1,1,0,1,1-1.39.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.89,278.77a1.41,1.41,0,1,1-1.41-1.41A1.41,1.41,0,0,1,415.89,278.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.68,303.54a1.51,1.51,0,1,1-.09-2.13A1.52,1.52,0,0,1,52.68,303.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.7,412.27a1.47,1.47,0,1,1,.12-2.08A1.48,1.48,0,0,1,75.7,412.27Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.68,378.89a.74.74,0,0,1-1-.05.75.75,0,0,1,.06-1,.74.74,0,1,1,1,1.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3,408.1a.74.74,0,0,1-1-.05.75.75,0,0,1,.06-1.05.74.74,0,1,1,1,1.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.74,384.33a.74.74,0,0,1-1-.06.74.74,0,1,1,1.1-1A.74.74,0,0,1,79.74,384.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.43,328.59a.52.52,0,1,1,0-.74A.51.51,0,0,1,80.43,328.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,129.21a1.11,1.11,0,1,1,0,1.58A1.11,1.11,0,0,1,420,129.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.25,191.66a.5.5,0,0,1,.74.66.5.5,0,0,1-.74-.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.56,191.56a.5.5,0,1,1,0,.7A.5.5,0,0,1,449.56,191.56Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,67.36a1.39,1.39,0,1,1-1.25,1.51A1.38,1.38,0,0,1,234,67.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.72,302.73a.49.49,0,1,1-1,0,.49.49,0,0,1,1,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.66,409.26l3.76,1.65,3.49-2.15a.41.41,0,0,1,.63.39l-.41,4.09,3.13,2.65a.42.42,0,0,1-.18.73l-4,.86-1.55,3.8a.42.42,0,0,1-.75.05l-2.06-3.55-4.09-.31a.41.41,0,0,1-.28-.69l2.73-3.06-1-4A.41.41,0,0,1,408.66,409.26Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.66,409.26l3.76,1.65,3.49-2.15a.41.41,0,0,1,.63.39l-.41,4.09,3.13,2.65a.42.42,0,0,1-.18.73l-4,.86-1.55,3.8a.42.42,0,0,1-.75.05l-2.06-3.55-4.09-.31a.41.41,0,0,1-.28-.69l2.73-3.06-1-4A.41.41,0,0,1,408.66,409.26Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,343.2l1.57-1.56-.4-2.18a.22.22,0,0,1,.32-.24l2,1,2-1.05a.22.22,0,0,1,.32.23l-.35,2.18,1.61,1.53a.22.22,0,0,1-.12.38l-2.19.35-.95,2a.22.22,0,0,1-.4,0l-1-2-2.19-.3A.23.23,0,0,1,433.25,343.2Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.25,343.2l1.57-1.56-.4-2.18a.22.22,0,0,1,.32-.24l2,1,2-1.05a.22.22,0,0,1,.32.23l-.35,2.18,1.61,1.53a.22.22,0,0,1-.12.38l-2.19.35-.95,2a.22.22,0,0,1-.4,0l-1-2-2.19-.3A.23.23,0,0,1,433.25,343.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,396l2.2-.26,1-2a.23.23,0,0,1,.4,0l.93,2,2.18.38a.22.22,0,0,1,.11.38l-1.62,1.5.32,2.19a.22.22,0,0,1-.33.23l-1.93-1.08-2,1a.23.23,0,0,1-.32-.24l.43-2.17-1.54-1.59A.23.23,0,0,1,401.88,396Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,396l2.2-.26,1-2a.23.23,0,0,1,.4,0l.93,2,2.18.38a.22.22,0,0,1,.11.38l-1.62,1.5.32,2.19a.22.22,0,0,1-.33.23l-1.93-1.08-2,1a.23.23,0,0,1-.32-.24l.43-2.17-1.54-1.59A.23.23,0,0,1,401.88,396Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.13,404.28a1,1,0,0,1-1.36,1.41,1,1,0,1,1,1.36-1.41Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.17,353.38a1,1,0,0,1,.88,1.07,1,1,0,0,1-1.08.88,1,1,0,0,1,.2-1.95Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.81,358.43a.5.5,0,0,1,.45.54.49.49,0,0,1-.54.44.5.5,0,0,1-.45-.54A.49.49,0,0,1,417.81,358.43Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.75,393.63a.48.48,0,0,1,0,.69.49.49,0,1,1-.71-.68A.48.48,0,0,1,418.75,393.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.18,428.82a.5.5,0,1,1-.7,0A.5.5,0,0,1,421.18,428.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.39,209.24a.48.48,0,0,1,.69,0,.49.49,0,1,1-.65.73A.48.48,0,0,1,441.39,209.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.17,80.84a.49.49,0,0,1,.54.44.5.5,0,0,1-.45.54.48.48,0,0,1-.53-.44A.49.49,0,0,1,208.17,80.84Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.07,306.28a.53.53,0,1,1,0-.75A.54.54,0,0,1,57.07,306.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.04,
    cy: 76.58,
    r: 1.75,
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68.04,
    cy: 76.58,
    r: 1.75,
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.54,466.8a1.14,1.14,0,1,1-1.49-.6A1.13,1.13,0,0,1,221.54,466.8Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.54,466.8a1.14,1.14,0,1,1-1.49-.6A1.13,1.13,0,0,1,221.54,466.8Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,72.06a.75.75,0,0,1-1.08-1,.76.76,0,0,1,1.07,0A.77.77,0,0,1,414.21,72.06Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.21,72.06a.75.75,0,0,1-1.08-1,.76.76,0,0,1,1.07,0A.77.77,0,0,1,414.21,72.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.64,264.45a1,1,0,0,1-.14,1.43,1,1,0,1,1,.14-1.43Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.64,264.45a1,1,0,0,1-.14,1.43,1,1,0,1,1,.14-1.43Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14,91.9a.76.76,0,1,1,0-1.06A.75.75,0,0,1,422.14,91.9Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.14,91.9a.76.76,0,1,1,0-1.06A.75.75,0,0,1,422.14,91.9Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,166.76a1,1,0,1,1-1-1A1,1,0,0,1,75.16,166.76Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.16,166.76a1,1,0,1,1-1-1A1,1,0,0,1,75.16,166.76Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.06,206.6a1,1,0,1,1-1-1A1,1,0,0,1,84.06,206.6Z",
    style: {
      fill: "#9D6B6B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.06,206.6a1,1,0,1,1-1-1A1,1,0,0,1,84.06,206.6Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWishlist);
export default __webpack_public_path__ + "static/media/Empty Wishlist.01e05529840319a8b80e5fd0177c4191.svg";
export { ForwardRef as ReactComponent };